

/**
 * It takes a Leaflet map, a list of coordinates, and some options, and then it either zooms the map to
 * fit all the coordinates, or it centers the map on the first coordinate in the list
 * @param leafletMap - The leaflet map object
 * @param listOfCoordinates - An array of coordinates.
 * @param [NOOP] - an empty object
 */
export function autoZoomMap(leafletMap, listOfCoordinates) {
  if (leafletMap && listOfCoordinates) {
    if (listOfCoordinates.length >= 1) {
      leafletMap.fitBounds(listOfCoordinates)
    }
  }
}
